export const lcvPrizePotConstants = {
    LCV_PRIZE_POT_GET_REQUEST:"LCV_PRIZE_POT_GET_REQUEST",
    LCV_PRIZE_POT_GET_COMPLETE:"LCV_PRIZE_POT_GET_COMPLETE",

    LCV_PRIZE_POT_SET_AVAILABILITY_REQUEST:"LCV_PRIZE_POT_SET_AVAILABILITY_REQUEST",
    LCV_PRIZE_POT_SET_AVAILABILITY_COMPLETE:"LCV_PRIZE_POT_SET_AVAILABILITY_COMPLETE",

    LCV_PRIZE_POT_INCREASE_QUANTITY_REQUEST:"LCV_PRIZE_POT_INCREASE_QUANTITY_REQUEST",
    LCV_PRIZE_POT_INCREASE_QUANTITY_COMPLETE:"LCV_PRIZE_POT_INCREASE_QUANTITY_COMPLETE",

    LCV_PRIZE_POT_CLEAR_ACTION_RESULT:"LCV_PRIZE_POT_CLEAR_ACTION_RESULT",

    LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_REQUEST:"LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_REQUEST",
    LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_COMPLETE:"LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_COMPLETE",

    LCV_PRIZE_POT_ADD_BUDGET_ENTRY_REQUEST:"LCV_PRIZE_POT_ADD_BUDGET_ENTRY_REQUEST",
    LCV_PRIZE_POT_ADD_BUDGET_ENTRY_COMPLETE:"LCV_PRIZE_POT_ADD_BUDGET_ENTRY_COMPLETE",
};
